"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.PopoverCore = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactPortal = require("react-portal");

var _reactPopper = require("react-popper");

var _reactTransitionGroup = require("react-transition-group");

var _ClickOutside = require("./utils/ClickOutside");

var _modifiers = require("./utils/modifiers");

var _filterDataProps = require("./utils/filter-data-props");

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _utils = require("./utils/utils");

var _helpers = require("./utils/helpers");

var _getAppendToElement = require("./utils/getAppendToElement");

var _context = require("../../WixStyleReactProvider/context");

var _PopoverSt = require("../Popover.st.css");

var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-style-react/dist/cjs/Popover/PopoverCore/PopoverCore.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// This is here and not in the test setup because we don't want consumers to need to run it as well
var testId = '0';
var isTestEnv = process.env.NODE_ENV === 'test';

if (isTestEnv && typeof document !== 'undefined' && !document.createRange) {
  _helpers.popoverTestUtils.createRange();
}

/**
 * Popover
 */
var PopoverCore = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PopoverCore, _React$Component);

  var _super = _createSuper(PopoverCore);

  // Timer instances for the show/hide delays
  function PopoverCore(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, PopoverCore);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "targetRef", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "portalNode", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "portalClasses", '');
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "appendToNode", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clickOutsideRef", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "popoverContentRef", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clickOutsideClass", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "contentHook", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "popperScheduleUpdate", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_hideTimeout", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_showTimeout", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleClickOutside", function (event) {
      var _this$props = _this.props,
          onClickOutsideCallback = _this$props.onClickOutside,
          shown = _this$props.shown,
          disableClickOutsideWhenClosed = _this$props.disableClickOutsideWhenClosed;

      if (onClickOutsideCallback && !(disableClickOutsideWhenClosed && !shown)) {
        onClickOutsideCallback(event);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
      var onEscPress = _this.props.onEscPress;

      if (onEscPress && e.key === 'Escape') {
        onEscPress(e);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onDocumentKeyUp", function (e) {
      var onTabOut = _this.props.onTabOut;

      if (typeof document !== 'undefined' && _this.popoverContentRef.current && !_this.popoverContentRef.current.contains(document.activeElement)) {
        onTabOut && onTabOut(e);
      }
    });
    _this.state = {
      isMounted: false,
      shown: props.shown || false
    };

    if (isTestEnv) {
      testId = _helpers.popoverTestUtils.generateId();
    }

    _this.clickOutsideRef = /*#__PURE__*/_react["default"].createRef();
    _this.popoverContentRef = /*#__PURE__*/_react["default"].createRef();
    _this.clickOutsideClass = (0, _uniqueId["default"])('clickOutside');
    _this.contentHook = "popover-content-".concat(props.dataHook || '', "-").concat(testId);
    return _this;
  }

  (0, _createClass2["default"])(PopoverCore, [{
    key: "focus",
    value: function focus() {
      if (this.popoverContentRef.current) {
        this.popoverContentRef.current.focus();
      }
    }
  }, {
    key: "getPopperContentStructure",
    value: function getPopperContentStructure(childrenObject) {
      var _this2 = this;

      var shown = this.state.shown;
      var _this$props2 = this.props,
          moveBy = _this$props2.moveBy,
          appendTo = _this$props2.appendTo,
          placement = _this$props2.placement,
          showArrow = _this$props2.showArrow,
          moveArrowTo = _this$props2.moveArrowTo,
          flip = _this$props2.flip,
          fixed = _this$props2.fixed,
          customArrow = _this$props2.customArrow,
          role = _this$props2.role,
          id = _this$props2.id,
          zIndex = _this$props2.zIndex,
          minWidth = _this$props2.minWidth,
          maxWidth = _this$props2.maxWidth,
          width = _this$props2.width,
          dynamicWidth = _this$props2.dynamicWidth,
          onEscPress = _this$props2.onEscPress,
          tabIndex = _this$props2.tabIndex,
          ariaLabel = _this$props2['aria-label'],
          ariaLabelledby = _this$props2['aria-labelledby'],
          ariaDescribedBy = _this$props2['aria-describedby'],
          timeout = _this$props2.timeout,
          theme = _this$props2.theme;
      var shouldAnimate = (0, _utils.shouldAnimatePopover)({
        timeout: timeout
      });
      var modifiers = (0, _modifiers.createModifiers)({
        minWidth: minWidth,
        width: width,
        dynamicWidth: dynamicWidth,
        moveBy: moveBy,
        appendTo: appendTo,
        shouldAnimate: shouldAnimate,
        flip: flip,
        placement: placement,
        fixed: fixed,
        isTestEnv: isTestEnv
      });

      var mergeRefs = function mergeRefs() {
        for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
          refs[_key] = arguments[_key];
        }

        var filteredRefs = refs.filter(Boolean);

        if (!filteredRefs.length) {
          return null;
        }

        if (filteredRefs.length === 0) {
          return filteredRefs[0];
        }

        return function (inst) {
          var _iterator = _createForOfIteratorHelper(filteredRefs),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var ref = _step.value;

              if (typeof ref === 'function') {
                ref(inst);
              } else if (ref) {
                ref.current = inst;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        };
      };

      var popperWithArrow = /*#__PURE__*/_react["default"].createElement(_reactPopper.Popper, {
        modifiers: modifiers,
        placement: placement,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 176,
          columnNumber: 7
        }
      }, function (_ref) {
        var ref = _ref.ref,
            popperStyles = _ref.style,
            popperPlacement = _ref.placement,
            arrowProps = _ref.arrowProps,
            scheduleUpdate = _ref.scheduleUpdate;
        _this2.popperScheduleUpdate = scheduleUpdate;
        return /*#__PURE__*/_react["default"].createElement("div", {
          "data-hook": "popover-content",
          className: (0, _PopoverSt.st)(_this2.clickOutsideClass, _this2.context.newBrandingClass),
          "data-content-element": _this2.contentHook,
          ref: ref,
          style: _objectSpread(_objectSpread({}, popperStyles), {}, {
            zIndex: zIndex
          }),
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 187,
            columnNumber: 13
          }
        }, showArrow && _this2.renderArrow(arrowProps, moveArrowTo, popperPlacement || placement, customArrow), /*#__PURE__*/_react["default"].createElement("div", {
          id: id,
          role: role,
          tabIndex: tabIndex,
          ref: _this2.popoverContentRef,
          style: {
            maxWidth: maxWidth
          },
          className: (0, _PopoverSt.st)(_PopoverSt.classes.content, {
            placement: popperPlacement || placement,
            skin: theme,
            hasArrow: true
          }),
          onKeyDown: shown && onEscPress ? _this2._onKeyDown : undefined,
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledby,
          "aria-describedby": ariaDescribedBy,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 204,
            columnNumber: 15
          }
        }, childrenObject.Content));
      });

      var popper = /*#__PURE__*/_react["default"].createElement(_reactPopper.Popper, {
        modifiers: modifiers,
        placement: placement,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 229,
          columnNumber: 7
        }
      }, function (_ref2) {
        var ref = _ref2.ref,
            popperStyles = _ref2.style,
            popperPlacement = _ref2.placement,
            scheduleUpdate = _ref2.scheduleUpdate;
        _this2.popperScheduleUpdate = scheduleUpdate;
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: id,
          ref: mergeRefs(ref, _this2.popoverContentRef),
          role: role,
          tabIndex: tabIndex,
          className: (0, _PopoverSt.st)(_PopoverSt.classes.content, {
            skin: theme,
            placement: popperPlacement || placement
          }, _this2.clickOutsideClass, _this2.context.newBrandingClass),
          "data-hook": "popover-content",
          style: _objectSpread(_objectSpread({}, popperStyles), {}, {
            zIndex: zIndex,
            maxWidth: maxWidth
          }),
          "data-content-element": _this2.contentHook,
          onKeyDown: shown && onEscPress ? _this2._onKeyDown : undefined,
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledby,
          "aria-describedby": ariaDescribedBy,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 238,
            columnNumber: 13
          }
        }, childrenObject.Content);
      });

      return this.wrapWithAnimations(showArrow ? popperWithArrow : popper);
    }
  }, {
    key: "applyStylesToPortaledNode",
    value: function applyStylesToPortaledNode() {
      var shown = this.state.shown;
      var shouldAnimate = (0, _utils.shouldAnimatePopover)(this.props);

      if (shouldAnimate || shown) {
        (0, _utils.attachClasses)(this.portalNode, this.portalClasses);
      } else {
        (0, _utils.detachClasses)(this.portalNode, this.portalClasses);
      }
    }
  }, {
    key: "wrapWithAnimations",
    value: function wrapWithAnimations(popper) {
      var _this3 = this;

      var timeout = this.props.timeout;
      var shown = this.state.shown;
      var shouldAnimate = (0, _utils.shouldAnimatePopover)(this.props);
      return shouldAnimate ? /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
        "in": shown,
        timeout: timeout,
        unmountOnExit: true,
        classNames: {
          enter: _PopoverSt.classes.animationEnter,
          enterActive: _PopoverSt.classes.animationEnterActive,
          exit: _PopoverSt.classes.animationExit,
          exitActive: _PopoverSt.classes.animationExitActive
        },
        addEndListener: function addEndListener() {},
        onExited: function onExited() {
          return (0, _utils.detachClasses)(_this3.portalNode, _this3.portalClasses);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 288,
          columnNumber: 7
        }
      }, popper) : popper;
    }
  }, {
    key: "renderPopperContent",
    value: function renderPopperContent(childrenObject) {
      var popper = this.getPopperContentStructure(childrenObject);
      return this.portalNode ? /*#__PURE__*/_react["default"].createElement(_reactPortal.Portal, {
        node: this.portalNode,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 312,
          columnNumber: 7
        }
      }, popper) : popper;
    }
  }, {
    key: "renderArrow",
    value: function renderArrow(arrowProps, moveArrowTo, placement, customArrow) {
      var theme = this.props.theme;
      var commonProps = {
        ref: arrowProps.ref,
        key: 'popover-arrow',
        'data-hook': 'popover-arrow',
        style: _objectSpread(_objectSpread({}, arrowProps.style), (0, _utils.getArrowShift)(moveArrowTo, placement))
      };

      if (customArrow) {
        return customArrow(placement, commonProps);
      }

      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, commonProps, {
        className: (0, _PopoverSt.st)(_PopoverSt.classes.arrow, {
          skin: theme,
          placement: placement
        }),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 340,
          columnNumber: 7
        }
      }));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          shown = _this$props3.shown,
          onTabOut = _this$props3.onTabOut;
      this.initAppendToNode();

      if (onTabOut && shown) {
        this._setBlurByKeyboardListener();
      }

      this.setState({
        isMounted: true
      });
    }
    /**
     * Checks to see if the focused element is outside the Popover content
     */

  }, {
    key: "_setBlurByKeyboardListener",
    value: function _setBlurByKeyboardListener() {
      if (typeof document !== 'undefined') {
        document.addEventListener('keyup', this._onDocumentKeyUp, true);
      }
    }
  }, {
    key: "_removeBlurListener",
    value: function _removeBlurListener() {
      if (typeof document !== 'undefined') {
        document.removeEventListener('keyup', this._onDocumentKeyUp, true);
      }
    }
  }, {
    key: "initAppendToNode",
    value: function initAppendToNode() {
      var appendTo = this.props.appendTo;
      this.appendToNode = (0, _getAppendToElement.getAppendToElement)(appendTo, this.targetRef);

      if (this.appendToNode) {
        this.portalNode = document.createElement('div');
        this.portalNode.setAttribute('data-hook', 'popover-portal');
        /**
         * reset overlay wrapping layer
         * so that styles from copied classnames
         * won't break the overlay:
         * - content is position relative to body
         * - overlay layer is hidden
         */

        Object.assign(this.portalNode.style, {
          position: 'static',
          display: 'block',
          top: 0,
          left: 0,
          width: 0,
          height: 0
        });
        this.appendToNode.appendChild(this.portalNode);
      }
    }
  }, {
    key: "hidePopover",
    value: function hidePopover() {
      var _this4 = this;

      var isMounted = this.state.isMounted;
      var _this$props4 = this.props,
          hideDelay = _this$props4.hideDelay,
          onTabOut = _this$props4.onTabOut;

      if (!isMounted || this._hideTimeout) {
        return;
      }

      if (this._showTimeout) {
        clearTimeout(this._showTimeout);
        this._showTimeout = null;
      }

      if (onTabOut) {
        this._removeBlurListener();
      }

      if (hideDelay) {
        this._hideTimeout = setTimeout(function () {
          _this4.setState({
            shown: false
          });
        }, hideDelay);
      } else {
        this.setState({
          shown: false
        });
      }
    }
  }, {
    key: "showPopover",
    value: function showPopover() {
      var _this5 = this;

      var isMounted = this.state.isMounted;
      var _this$props5 = this.props,
          showDelay = _this$props5.showDelay,
          onTabOut = _this$props5.onTabOut;

      if (!isMounted || this._showTimeout) {
        return;
      }

      if (this._hideTimeout) {
        clearTimeout(this._hideTimeout);
        this._hideTimeout = null;
      }

      if (onTabOut) {
        this._setBlurByKeyboardListener();
      }

      if (showDelay) {
        this._showTimeout = setTimeout(function () {
          _this5.setState({
            shown: true
          });
        }, showDelay);
      } else {
        this.setState({
          shown: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.portalNode && this.appendToNode && this.appendToNode.children.length) {
        // FIXME: What if component is updated with a different appendTo? It is a far-fetched use-case,
        // but we would need to remove the portaled node, and created another one.
        this.appendToNode.removeChild(this.portalNode);
      }

      this.portalNode = null;

      if (this._hideTimeout) {
        clearTimeout(this._hideTimeout);
        this._hideTimeout = null;
      }

      if (this._showTimeout) {
        clearTimeout(this._showTimeout);
        this._showTimeout = null;
      }
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (this.popperScheduleUpdate) {
        this.popperScheduleUpdate();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var shown = this.props.shown;

      if (this.portalNode) {
        // Re-calculate the portal's styles
        this.portalClasses = (0, _PopoverSt.st)(_PopoverSt.classes.root, this.props.className); // Apply the styles to the portal

        this.applyStylesToPortaledNode();
      } // Update popover visibility


      if (prevProps.shown !== shown) {
        if (shown) {
          this.showPopover();
        } else {
          this.hidePopover();
        }
      } else {
        // Update popper's position
        this.updatePosition();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props6 = this.props,
          onMouseEnter = _this$props6.onMouseEnter,
          onMouseLeave = _this$props6.onMouseLeave,
          onKeyDown = _this$props6.onKeyDown,
          onClick = _this$props6.onClick,
          children = _this$props6.children,
          style = _this$props6.style,
          id = _this$props6.id,
          fluid = _this$props6.fluid,
          dataHook = _this$props6.dataHook,
          zIndex = _this$props6.zIndex;
      var _this$state = this.state,
          isMounted = _this$state.isMounted,
          shown = _this$state.shown;
      var childrenObject = (0, _utils.buildChildrenObject)(children, {
        Element: null,
        Content: null
      });
      var shouldAnimate = (0, _utils.shouldAnimatePopover)(this.props);
      var shouldRenderPopper = isMounted && (shouldAnimate || shown);
      return /*#__PURE__*/_react["default"].createElement(_reactPopper.Manager, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 536,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react["default"].createElement(_ClickOutside.ClickOutside, {
        rootRef: this.clickOutsideRef,
        onClickOutside: shown ? this._handleClickOutside : undefined,
        excludeClass: this.clickOutsideClass,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 537,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        ref: this.clickOutsideRef,
        style: style,
        "data-hook": dataHook,
        "data-content-hook": this.contentHook,
        className: (0, _PopoverSt.st)(_PopoverSt.classes.root, {
          fluid: fluid
        }, this.props.className),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-zindex": zIndex,
        id: id
      }, (0, _filterDataProps.filterDataProps)(this.props), {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 542,
          columnNumber: 11
        }
      }), /*#__PURE__*/_react["default"].createElement(_reactPopper.Reference, {
        innerRef: function innerRef(r) {
          return _this6.targetRef = r;
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 554,
          columnNumber: 13
        }
      }, function (_ref3) {
        var ref = _ref3.ref;
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: ref,
          className: _PopoverSt.classes.element,
          "data-hook": "popover-element",
          onClick: onClick,
          onKeyDown: onKeyDown,
          __self: _this6,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 556,
            columnNumber: 17
          }
        }, childrenObject.Element);
      }), shouldRenderPopper && this.renderPopperContent(childrenObject))));
    }
  }]);
  return PopoverCore;
}(_react["default"].Component);

exports.PopoverCore = PopoverCore;
(0, _defineProperty2["default"])(PopoverCore, "displayName", 'Popover');
(0, _defineProperty2["default"])(PopoverCore, "defaultProps", {
  flip: true,
  fixed: false,
  zIndex: 1000,
  shown: false,
  placement: 'bottom',
  excludeClass: ''
});
(0, _defineProperty2["default"])(PopoverCore, "contextType", _context.WixStyleReactContext);
(0, _defineProperty2["default"])(PopoverCore, "Element", (0, _utils.createComponentThatRendersItsChildren)('Popover.Element'));
(0, _defineProperty2["default"])(PopoverCore, "Content", (0, _utils.createComponentThatRendersItsChildren)('Popover.Content'));
//# sourceMappingURL=PopoverCore.js.map